import { BaseWidget } from 'models/WidgetModel';
import React from 'react';
interface CustomWidgetProps extends BaseWidget {
  colors: string[];
}
const CustomWidget: React.FC<CustomWidgetProps> = () => {
  return <div>My Custom Widget</div>;
};
export default CustomWidget;
